var o = function(r, f) {
  for (var a in r)
    f(r[a], a);
};
export {
  o as f
};
